
export default {
  data() {
    return {
      filterOpen: false,
      queryItems: [],
      showChecbox: false,
      geoPositions: [],
      allProducts: [],
      filterSimilarCapacity: false,

      options: [
        {
          name: "locationCoordinates",
          label: "Coordinates",
          type: "coordinates",
        },
        {
          name: "itemName",
          label: "Item name",
          type: "text",
        },
        {
          name: "itemAddress",
          label: "Item address",
          type: "text",
        },
        {
          name: "city",
          label: "City",
          type: "text",
        },
        {
          name: "price",
          label: "Price",
          type: "text",
        },
        {
          name: "capacity",
          label: "Capacity",
          type: "text",
        },
      ],
    };
  },

  beforeMount() {
    this.$nextTick(() => {
      const body = document.documentElement;
      body.classList.add("product-list-page");
    });
  },

  mounted() {
    if (
      this.$refs.controllerProducts &&
      this.$refs.controllerProducts.options
    ) {
      this.$refs.controllerProducts.options.sort = "Najviše prioritetni";
      this.$refs.controllerProducts.fetchData();
    }

    this.$watch(
      () => {
        return this.$refs.controllerProducts?.options?.page;
      },
      (val) => {
        this.$router.push({ query: { page: val } });
      }
    );

    if (this.$route && this.$route.query && this.$route.query.page) {
      if (
        this.$refs.controllerProducts &&
        this.$refs.controllerProducts.options &&
        this.$refs.controllerProducts.options.page
      ) {
        this.$refs.controllerProducts.options.page = parseInt(
          this.$route.query.page
        );
      }
    }

    setTimeout(() => {
      this.getGeoPositions();
    }, 300);
  },

  destroyed() {
    const body = document.documentElement;
    body.classList.remove("product-list-page");
  },

  methods: {
    toggleFilterModal() {
      this.filterOpen = !this.filterOpen;
    },
    closeFilterModal() {
      this.filterOpen = false;
    },

    showSimilarCapacityChecbox() {
      this.showChecbox = true;
    },

    getGeoPositions() {
      if (
        this.$refs.mapProducts &&
        this.$refs.mapProducts.items &&
        this.$refs.mapProducts.items.length
      ) {
        this.geoPositions = [];
        const products = this.$refs.mapProducts.items;

        products.forEach((product) => {
          if (
            product.attributeSet &&
            product.attributeSet.attributes &&
            product.attributeSet.attributes.length
          ) {
            const productAttributes = product.attributeSet.attributes;
            let lat, long, itemName, itemAddress, city, capacity, price;

            productAttributes.forEach((att) => {
              if (att.attributeCode === "att_latitude_textField" && att.value) {
                lat = att.value;
              }
              if (
                att.attributeCode === "att_longitude_textField" &&
                att.value
              ) {
                long = att.value;
              }

              if (att.attributeCode === "att_broj-osoba_numberField") {
                capacity = att.value;
              }
              if (att.attributeCode === "att_adresa-objekta_textField") {
                itemAddress = att.value;
              }
            });

            if (product.categories && product.categories.length) {
              city = product.categories[0].name;
            }
            price = product.retailPrice;
            itemName = `${this.$t("text.apartmentFor")}${capacity} ${
              capacity === 1 ? this.$t("text.worker") : this.$t("text.workers")
            } - ${city}`;

            if (lat && long) {
              if (typeof lat === "string" && typeof long === "string") {
                lat = lat.replace(",", ".");
                long = long.replace(",", ".");
              }

              this.geoPositions.push({
                $id: product.id,
                locationCoordinates: {
                  lat: lat,
                  long: long,
                },
                itemName: itemName,
                itemAddress: itemAddress,
                capacity: capacity,
                city: city,
                price: price,
              });
            }
          }
        });

        this.setGeoPositionsOnMap();
      }
    },

    setGeoPositionsOnMap() {
      this.$refs.map.markers = [];
      this.$refs.list.items = [];

      if (this.geoPositions && this.geoPositions.length && this.$refs.list) {
        var markers = [];

        this.geoPositions.forEach((position) => {
          this.$refs.list.items.push(position);
          var geoLat = position.locationCoordinates?.lat;
          var geoLong = position.locationCoordinates?.long;
          var itemName = position.itemName;
          var itemAddress = position.itemAddress;
          var price = position.price;
          var city = position.city;
          var capacity = position.capacity;

          if (typeof geoLat === "string" && typeof geoLong === "string") {
            geoLat = geoLat.replace(",", ".");
            geoLong = geoLong.replace(",", ".");
          }

          markers.push({
            coordinates: [Number(geoLat), Number(geoLong)],
            popupItem: {
              $id: position.$id,
              locationCoordinates: {
                lat: geoLat,
                long: geoLong,
              },
              itemName: itemName,
              itemAddress: itemAddress,
              city: city,
              price: price,
              capacity: capacity,
            },
          });
        });

        setTimeout(() => {
          this.$refs.map.markers = markers;
        }, 500);
      }
    },
  },
};
